
<template>
    <div>
        <el-radio-group v-model="radio" @change="handleCheckedQes" class="examRadio" :class="{'selected':isSelected || look }" :disabled='(isSelected || look)'>
            <el-radio label='1' :class='[letter(0),answerRightError(0,list.answer)]'>对</el-radio>
            <el-radio label='2' :class='[letter(1),answerRightError(1,list.answer)]'>错</el-radio>
        </el-radio-group>
        <div class="answerBox" v-show='isSelected || look'>
            <p>正确答案：{{ letterAnswer(list.answer-1) }}</p>
            <p>我的答案：{{ letterAnswer(selected[this.list.qid]-1) }}</p>
        </div>
    </div>

</template>
<script>
export default {
    props: {
        list: {
            type: Object
        },
        selected: {
            type: Object
        },
        look: {
            type: Boolean
        },
    },
    computed: {
        /**
         * 转化字母 添加class
         */
        letter () {
            return function (param) {
                return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'][param];
            }
        },
        /**
         * 转化字母 添加class
         */
        letterAnswer () {
            return function (param) {
                return ['对','错'][param];
            }
        },
        /**
         * 判断选项是正确还是错误  添加class
         */
        answerRightError () {
            return function (idx, answer) {
                idx = idx + 1;
                if (idx == answer) {
                    return 'ok';
                }else{
                    if (this.selected[this.list.qid] == idx) {
                        return 'error'
                    } 
                }
                return '';
            }
        },

    },
    watch: {
        selected () {
            if (this.selected[this.list.qid]) {

                this.isSelected = true;
                //获取选中的下标
                // this.answerError = this.selected[this.list.qid];
            } else {
                this.isSelected = false;
            }
        }
    },

    data () {
        return {
            radio: '',
            isSelected: false,
        }
    },
    mounted () {
        console.log(this.list)
    },
    methods: {
        /**
         * 选择事件
         */
        handleCheckedQes () {
            console.log('改变了')
            console.log(this.radio)
            // this.list.isChecked = true;11
            // if (this.selected[this.list.qid]) {
            //     // this.$message('已经训啊过了');
            //     return false;
            // }

            //正确
            if (this.list.answer == this.radio ) {

            } else {//错误

            }

            let obj = {};
            obj[this.list.qid] = this.radio;
            this.$emit('changeQes', obj)
        }
    }
}
</script>
<style lang="stylus" scoped>
.answerBox
    width 376px
    p 
        color #333333
        font-size 16px
        text-align center
.el-radio
    display block
    margin-bottom 20px
</style>
<style lang="stylus">
.el-carousel__container
    height 400px
// .examRadio
//     // background red
//     .el-radio
//         .el-radio__label
//             font-size 16px
//             color #4D4D4D
//             line-height 28px
//             font-weight normal
//         .el-radio__inner
//             width 28px
//             height 28px
//             line-height 28px
//             border 0 !important
//             background-size 100% 100% !important
//             background-image url('~@/assets/images/circle.png')
//             position relative
//         .el-radio__inner::after
//             width 28px
//             height 28px
//             font-size 14px
//             text-align center
//             background none
//             transform scale(1)
//             top 0
//             left 0
//     .el-radio.A
//         .el-radio__inner::after
//             content 'A'
//     .el-radio.B
//         .el-radio__inner::after
//             content 'B'
//     .el-radio.C
//         .el-radio__inner::after
//             content 'C'
//     .el-radio.D
//         .el-radio__inner::after
//             content 'D'
//     .el-radio.E
//         .el-radio__inner::after
//             content 'E'
//     .el-radio.F
//         .el-radio__inner::after
//             content 'F'
//     .el-radio.G
//         .el-radio__inner::after
//             content 'G'
//     .el-radio.H
//         .el-radio__inner::after
//             content 'H'
// .examRadio.selected
//     .el-radio__inner
//         background none
//     .ok
//         .el-radio__inner
//             background-image url('~@/assets/images/ok.png') !important
//         .el-radio__inner::after
//             content '' !important
//     .error
//         .el-radio__inner
//             background-image url('~@/assets/images/error.png') !important
//         .el-radio__inner::after
//             content '' !important
</style>


// WEBPACK FOOTER //
// src/components/my/exam/judge.vue